import React ,{useState}from 'react'
import {CSSTransition} from 'react-transition-group'
import i18n from '../../Localization/i18n'
import { ReactComponent as ChevronRightIcon } from '../../assets/chevron-right.svg';
import { ReactComponent as ChevronLeftIcon } from '../../assets/chevron-left.svg';
import { ReactComponent as USFlag } from '../../assets/flags/US.svg';
import { ReactComponent as FRFlag } from '../../assets/flags/FR.svg';
import { ReactComponent as SAFlag } from '../../assets/flags/SA.svg';
import { ReactComponent as DEFlag } from '../../assets/flags/DE.svg';
import { ReactComponent as TNFlag } from '../../assets/flags/TN.svg';

import './Dropdown.scss'

export function Dropdown({children}) {
  return (
   <>
    <ul className='app__dropdown-container'>
        {children}
    </ul>
   </>
  )
}

export function DropdownItem(props) {
    return (
        <>
        <li className='app__dropdown-item'>
             <a className="app__dropdown-item-element" onClick={()=> props.children && props.setOpen(!props.open)}>
                {props.icon}
             </a>
             {props.open && props.children}
         </li>
        </>
    )
  }

      

  export function DropDownMenu(props) {
    const [activeMenu, setActiveMenu] = useState('languages')
    const [menuHeight,setMenuHeight]=useState(null)

    const calcHeight = (el) => {
        const height=el.offsetHeight+25
        setMenuHeight(height)
    }
    const collapseDropdown=() => {
        props.setOpen(false)
    }

    function DropDownMenuItem(props) {
        const handleItemClick=() => {

            if(props.goToMenu) 
            {setActiveMenu(props.goToMenu)
            return;
            }
            i18n.changeLanguage(props.languageCode)

            //  if (props.languageCode==='ar' || props.languageCode==='tn') {
            //     document.body.dir = 'rtl'
            //  }
            //  else {
            //     document.body.dir = 'ltr'
            //  }
            
            collapseDropdown()
        }

        return (
            <a className='app__dropdown-menu-item' 
             onClick={handleItemClick}
            >
                <span className='app__dropdonw-menu-icon app__dropdown-menu-icon-button'>{props.leftIcon}</span>
                {props.children}
                <span className='app__dropdonw-menu-icon app__dropdown-menu-icon-right'>{props.rightIcon}</span>
         </a>
        )
    }
    return (
        <div className='app__dropdown-menu' style={{height:menuHeight}}>
            <CSSTransition in={activeMenu==='languages'} unmountOnExit timeout={0}  onEnter={calcHeight} classNames='app__menu_primary'>
            <div className='app__menu'>
                <DropDownMenuItem 
                    leftIcon={<USFlag/>}
                    languageCode='en'>
                    English
                </DropDownMenuItem>
                <DropDownMenuItem 
                    leftIcon={<FRFlag/>}
                    languageCode='fr'>
                    français
                </DropDownMenuItem>
                <DropDownMenuItem 
                 goToMenu='arabic' 
                    leftIcon={<SAFlag/>}
                    rightIcon={<ChevronRightIcon/>}>
                    العربية
                </DropDownMenuItem>
                <DropDownMenuItem 
                    leftIcon={<DEFlag/>}
                    languageCode='de'>
                    Deutsch
                </DropDownMenuItem>
            </div>
            </CSSTransition>


            <CSSTransition
        in={activeMenu === 'arabic'}
        timeout={500}
        classNames="app__menu-secondary"
        unmountOnExit
        onEnter={calcHeight}>
        <div className="app__menu">
        <DropDownMenuItem 
           goToMenu='languages' 
                    leftIcon={<ChevronLeftIcon/>}>
                    Back
                </DropDownMenuItem>
        <DropDownMenuItem 
                    rightIcon={<SAFlag/>}
                    languageCode='ar'>
                    العربية
                </DropDownMenuItem>
              <DropDownMenuItem 
                    rightIcon={<TNFlag/>}
                    languageCode='tn'>
                    التونسية
                </DropDownMenuItem>
        </div>
      </CSSTransition>
        </div>
    )
  }

